import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ShippingService } from 'src/app/services/shipping.service';
import { ProductModel } from 'src/app/models/wardrobe.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-seller-shipping-address',
  templateUrl: './seller-shipping-address.component.html',
  styleUrls: ['./seller-shipping-address.component.scss']
})
export class SellerShippingAddressComponent implements OnInit {
  shippingForm: FormGroup;
  errorMessage = '';
  isLoading = false;
  userType = 'seller'; // Default user type, can be changed based on context
  orderType = 'shipping'; // Default order type, can be changed based on context
  saveAddress = 0; // Default value, can be changed based on user input
  @Input() userId!: number;
  @Input() productId!: number;
  @Input() offered_product_id!: number;
  @Input() product!: ProductModel;
  @Input() chatId!: string;
  @Input() prefillData: any;
showBtnUserPrefilled: boolean;
  constructor(
    private modalCtrl: ModalController,
    private fb: FormBuilder,
    protected translate: TranslateService,
    private sendCloudService: ShippingService
  ) {
    this.shippingForm = this.fb.group({
      name: ['', [Validators.required, Validators.pattern('^[A-Za-zÀ-ÿ\\s\'-]{2,}$')]],
      address: ['', Validators.required],
      house_number: ['', Validators.required],
      // street: ['', Validators.required],
      postalCode: ['', [Validators.required, Validators.pattern('^[1-9][0-9]{3}\\s?[A-Za-z]{2}\\s?$')]],
      city: ['', [Validators.required, Validators.pattern("^[A-Za-zÀ-ÿ\\s'-]{2,}$")]],
      country: ['', Validators.required],
      phone: ['', [Validators.required, Validators.pattern('^((\\+31\\s?6\\s?[0-9]{8})|(06\\s?[0-9]{8}))\\s?$')]],
      saveAddress: [0]
    });
  }

  ngOnInit() {
    if (!this.productId || !this.userId) {
      console.error('Missing productId or userId', this.productId, this.userId);
    }

  // Check if valid saved address exists
  const saved = this.prefillData?.shipping_details;
  if (
    saved &&
    (saved.name || saved.address || saved.street || saved.postal_code || saved.city)
  ) {
    this.showBtnUserPrefilled = true;
  }
  else {
    this.showBtnUserPrefilled = false;
  }
  }

  async submit() {
    if (this.shippingForm.invalid) {
      this.shippingForm.markAllAsTouched();
      this.errorMessage = this.translate.instant('ShippingAddress.Errors.submitFailed');
      return;
    }

    this.isLoading = true;
    const formDetails = this.shippingForm.value;

    const payload = {
      // delivery_type: '', // can be passed via input if needed
      name: formDetails.name,
      address: formDetails.address,
      house_number: formDetails.house_number,
      // street: formDetails.street,
      city: formDetails.city,
      country: formDetails.country,
      postal_code: formDetails.postalCode,
      // shipping_status: '', // can be passed via input if needed
      phone_number: formDetails.phone,
      // shipping_method_id: formDetails.shippingMethod,
      shipping_method_id: null,
      chat_id: this.chatId
    };

    try {
      await this.sendCloudService.sendOrderToCloud(
        this.userId,
        this.productId,
        this.offered_product_id,
        this.userType,
        this.orderType,
        formDetails.saveAddress, // 1 or 0
        // this.saveAddress,
        payload
      ).toPromise();
   
      await this.modalCtrl.dismiss({
        address: {
          name: formDetails.name,
          house_number: formDetails.house_number,
          address: formDetails.address,
          street: formDetails.street,
          city: formDetails.city,
          country: formDetails.country,
          postalCode: formDetails.postalCode,
        },
        saveAddress: formDetails.saveAddress
      }, 'submit');

    } catch (error) {
      console.error('Error submitting shipping details:', error);
      // this.errorMessage = 'Something went wrong while submitting the shipping details.';
      this.errorMessage = this.translate.instant('ShippingAddress.Errors.submitFailed');
    } finally {
      this.isLoading = false;
    }
  }
useSavedAddress() {
  const shipping = this.prefillData?.shipping_details;

  if (!shipping) {
    this.errorMessage = this.translate.instant('ShippingAddress.Errors.noSavedAddress');
    return;
  }

  this.shippingForm.patchValue({
    name: shipping.name || '',
    house_number: shipping.house_number || '',
    address: shipping.address || '',
    street: shipping.street || '',
    postalCode: shipping.postal_code || '',
    city: shipping.city || '',
    country: shipping.country || '',
    phone: shipping.phone_number || '',
    saveAddress: this.prefillData.saveAddress ? 1 : 0
  });

  this.errorMessage = ''; // clear any previous error
}

onSaveAddressChange(event: any) {
  const isChecked = event.detail.checked;
  this.shippingForm.get('saveAddress')?.setValue(isChecked ? 1 : 0);
}
  dismiss() {
    this.modalCtrl.dismiss(null, 'cancel');
  }

}
